import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const FullScreenLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background" data-testid="auth-loading">
    <img src="/brand/simbolo-viola.png" alt="" className="h-12 w-auto animate-pulse dark:hidden" />
    <img src="/brand/simbolo-bianco.png" alt="" className="hidden h-12 w-auto animate-pulse dark:block" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
